import { useState } from 'react';
import { Form } from 'react-bootstrap';
import './scale-select.scss';

export const ScaleSelect = ({
  options,
  isInvalid,
  onChange,
  ...rest
}: {
  onChange?: (value: any) => void;
  isInvalid: boolean;
  options: { [key: string]: string };
}) => {
  const [selectedValue, setSelectedValue] = useState(null);

  const handleSelection = (value) => {
    setSelectedValue(value);
  };

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <div
        className="rounded scale-select-bar"
        style={{
          width: `calc(100% - 100%/${Object.keys(options).length} + 16px)`,
          left: `calc(100%/${Object.keys(options).length}/2 - 8px)`,
        }}
      />
      {Object.entries(options).map(([value, label]) => (
        <label
          key={value}
          className="d-flex flex-column align-items-center justify-content-center flex-grow-1 flex-shrink-1 flex-basis-0"
          style={{
            flexBasis: 0,
          }}
        >
          <Form.Check
            type="radio"
            value={value}
            checked={selectedValue === value}
            {...rest}
            isInvalid={isInvalid}
            onChange={(e) => {
              handleSelection(value);
              if (onChange) onChange(value);
            }}
            style={{ width: 'auto' }}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
};
